<template>
  <div>
    <block v-if="loading"></block>
    <v-toolbar color="comment" rounded="lg" dense class="mb-4">
      <v-spacer></v-spacer>
      <v-btn small class="btnclean mr-1" @click.prevent="cleanData">
        <v-icon>mdi-broom</v-icon>
      </v-btn>
      <v-btn
        v-if="$store.getters['rolesUser/getCustomRole'](51)"
        small
        class="mr-1"
        color="#3498db"
        dark
        @click.prevent.stop="addNewTransfer"
      >
        <v-icon>mdi-content-save</v-icon> Realizar Combinación
      </v-btn>
    </v-toolbar>
    <v-row dense>
      <v-col cols="12" md="3">
        <date-picker
          label="Fecha: "
          @dateSelected="(param) => (date = param)"
          v-model="date"
          :value="date"
        ></date-picker>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          attach
          :items="warehouses"
          label="Almacén (Origen): "
          @change="getItemsFromWarehouseOrigin()"
          v-model="form.warehouseOrigin"
          item-text="Warehouse"
          item-value="ID_Warehouse"
          outlined
          dense
          :disabled="productsToTransfer.length > 0"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          attach
          :items="warehouses"
          label="Almacén (Destino): "
          v-model="form.warehouseDestination"
          item-text="Warehouse"
          item-value="ID_Warehouse"
          outlined
          dense
          :disabled="productsToTransfer.length > 0"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" align="center">
        <v-btn
          :disabled="!form.warehouseOrigin || !form.warehouseDestination"
          color="primary"
          @click.prevent="showPrices = !showPrices"
        >
          <v-icon>mdi-plus</v-icon>&nbsp;&nbsp;Agregar producto
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn
          block
          dark
          large
          color="comment"
          class="rounded-lg"
          @click.prevent="showNotes = !showNotes"
        >
          <v-icon>mdi-comment</v-icon>
          <span class="text-h6">Comentarios</span>
        </v-btn>
      </v-col>
      <v-col cols="12" class="my-2">
        <div class="text-subtitle-1 font-weight-medium">
          <b>Indicación:</b> Editar celda (Unidades a transferir) para
          especificar la cantidad a transferir al almacén destino
        </div>
      </v-col>
    </v-row>
    <GeneralFilter
      entity="producto"
      :filterEndpoint="filterTransferProduct"
      :search="search"
      @emptyFilter="getProductsToShow"
      @filtered="filterHandler"
    >
      <DxDataGrid 
        ref="mainDataGrid"
        :data-source="productsToTransfer"
        @row-updating="onMainRowUpdating"
      >
        <DxExport :enabled="true" />
        <DxEditing
          :allow-updating="true"
          :select-text-on-edit-start="true"
          start-edit-action="click"
          mode="cell"
        />
        <DxColumn cell-template="show-template" caption=""></DxColumn>
        <template #show-template="{ data }">
          <v-btn
            icon
            small
            @click.prevent.stop="
              productsTransferShow(data.data.composedOf, data.rowIndex)
            "
          >
            <v-icon color="primary">mdi-eye</v-icon>
          </v-btn>
        </template>
        <DxColumn
          data-field="ItemComercialName"
          caption="Nombre de Producto"
        ></DxColumn>
        <DxColumn
          data-field="Quantity"
          header-cell-template="headerNameAmount"
          data-type="number"
        >
        </DxColumn>
        <template #headerNameAmount="{}"
          ><div>Unidades a<br />transferir</div></template
        >
        <DxColumn
          :width="columnWidth"
          :allow-editing="false"
          cell-template="WarehouseDestinyTemplate"
          data-field="WarehouseDestiny"
          caption="Almacén (Destino)"
        ></DxColumn>
        <template #WarehouseDestinyTemplate>
          {{
            `${warehouses.filter(item => item.ID_Warehouse === form.warehouseDestination)[0].Warehouse}`
          }}
        </template>
        <DxColumn
          :width="columnWidth"
          :allow-editing="false"
          data-field="ItemCurrentQuantity"
          caption="Existencia actual"
        ></DxColumn>
        <DxColumn
          :width="columnWidth"
          cell-template="lote-template2"
          data-field="ItemLote"
          caption="Lote"
        ></DxColumn>
        <template #lote-template2="{ data }">
          {{
            data.data.ID_ItemBatchAtDestination
              ? data.data.ID_ItemBatchAtDestination
              : "Por defecto"
          }}
        </template>

        <DxColumn :width="40" cell-template="show-template3" caption="">
        </DxColumn>
        <template #show-template3="{ data }">
          <a href="#" class="mx-1" @click.prevent.stop="removeRow(data)">
            <v-icon color="error">mdi-delete</v-icon>
          </a>
        </template>
      </DxDataGrid>
    </GeneralFilter>

    <v-dialog v-model="showPrices" width="80%" scrollable>
      <v-card>
        <v-card-title class="text-h5">
          Productos agregados {{ counter }}
          <v-spacer />
          <v-btn small dark color="error" @click.prevent="closeDialogShowPrices">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-dialog v-model="showFilter" width="800" persistent scrollable>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    sm="12"
                    style="
                      display: flex;
                      justify-content: space-between;
                      margin-top: 1rem;
                    "
                  >
                    <div class="text-h5">Filtrar Productos</div>
                    <v-btn @click.prevent="clearFilters" class="btnclean">
                      Limpiar Filtros
                    </v-btn>
                  </v-col>

                  <v-col cols="12" md="12" sm="12">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          outlined
                          dense
                          label="proveedor"
                          v-model="filter.providers"
                          :items="warehouses"
                          item-text="ProviderName"
                          attach
                          item-value="ID_Provider"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          outlined
                          dense
                          label="Familia"
                          v-model="filter.family"
                          :items="families"
                          item-text="name"
                          attach
                          item-value="id"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          outlined
                          dense
                          label="Categoría"
                          v-model="filter.category"
                          :items="filteredCategories"
                          item-text="name"
                          attach
                          item-value="id"
                          :disabled="!filter.family"
                        ></v-autocomplete>
                      </v-col>
                      <v-col>
                        <v-autocomplete
                          outlined
                          dense
                          label="Subcategoría"
                          v-model="filter.subcategory"
                          :items="filteredSubcategories"
                          attach
                          item-text="name"
                          item-value="id"
                          :disabled="!filter.category"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                    sm="12"
                    style="
                      display: flex;
                      justify-content: flex-end;
                      margin-top: 0.6rem;
                    "
                  >
                    <v-btn @click.prevent="filterProductsDt" class="btn-save">
                      Aplicar Filtros
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-row>
            <v-col cols="12" class="mt-3">
              <v-btn v-if="showDeselect" class="btn-save" @click="deselectAll">Deseleccionar todas</v-btn>
              <v-btn v-else @click="selectAll" class="btn-save">Seleccionar todas</v-btn>
              <v-btn class="ml-2 btn-save" @click.prevent="addProducts" dark
                >Agregar</v-btn
              >
            </v-col>
            <VersatileFilter
              :columnsSearch="columsConfig"
              :disableDates="true"
              ref="generalFilter"
              :search="{}"
              :columnfilterEndpoint="
                $API.products.getProductInventoryHistoryByColumns
              "
              @emptyFilter="clearInventoryFilter"
              @filtered="handleInventoryFilter"
            >
              <div v-if="loadingProducts" class="d-flex justify-center align-center" style="min-height: 400px;">
                <spinner></spinner>
              </div>
              <DxDataGrid
                v-else
                :data-source="products"
                key-expr="ID_Item"
                :show-row-lines="showRowLines"
                @exporting="onExporting"
                :show-borders="showBorders"
                :row-alternation-enabled="rowAlternationEnabled"
                :scrolling="{ useNative: true }"
                :column-auto-width="true"
              >
                <DxExport :enabled="true" />

                <DxColumn cell-template="show-template" caption=""></DxColumn>
                <DxPaging :page-size="5" />
                <DxColumn
                  :width="columnWidth"
                  data-field="ID_Item"
                  caption="ID de Producto/Servicio"
                ></DxColumn>
                <DxColumn
                  :width="columnWidth"
                  data-field="PrincipalBarCode"
                  caption="Código Alterno Principal"
                ></DxColumn>
                <!--DxColumn
                  :width="columnWidth"
                  data-field="WarehouseName"
                  caption="Almacen"
                ></DxColumn-->
                <DxColumn
                  :width="columnWidth"
                  cell-template="stock-template"
                  caption="Existencia"
                ></DxColumn>
                <DxColumn
                  :width="columnWidth"
                  cell-template="lote-template"
                  caption="lote"
                ></DxColumn>
                <DxColumn
                  data-field="ItemName"
                  caption="Nombre de Producto/Servicio"
                ></DxColumn>
                <template #show-template="{ data }">
                  <v-checkbox v-model="data.data.checkbox" class="pt-0" @click="updateCounter()">
                  </v-checkbox>
                </template>
                <template #stock-template="{ data }">
                  {{ data.data.ItemCurrentQuantity }}
                  {{ data.data.ItemMeasureUnit }}
                </template>
                <template #lote-template="{ data }">
                  {{
                    data.data.ID_ItemBatch
                      ? data.data.ID_ItemBatch
                      : "Por defecto"
                  }}
                </template>
              </DxDataGrid>
            </VersatileFilter>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog max-width="1024" v-model="showNotes">
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-btn small dark color="error" @click.prevent="showNotes = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <quill-editor
            :content="form.notes"
            :options="quillOptions"
            @change="onEditorChange($event)"
          ></quill-editor>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog 
      v-model="detailProductTransfer" 
      max-width="90%" 
      @keydown.esc="closeDetailModal"
      @click:outside="closeDetailModal"
    >
      <v-card>
        <v-card-title>
          <div>
            <div>Detalle de Producto</div>
            <div v-if="currentProductName" class="text-subtitle-1 grey--text">{{ currentProductName }}</div>
          </div>
          <v-spacer />
          <v-btn
            small
            dark
            color="error"
            @click="closeDetailModal"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-alert
            v-if="hasInsufficientStockInDetail"
            type="error"
            border="left"
            colored-border
            elevation="2"
            class="mb-4"
          >
            <strong>Sin Existencias:</strong> 
            <span v-if="currentProductName">El producto "{{ currentProductName }}" no puede ser combinado porque los</span>
            <span v-else>Los</span> componentes resaltados en rojo no tienen existencia suficiente para realizar la combinación.
          </v-alert>
          <DxDataGrid
            style="width: 100%"
            ref="dxDataGridTransfer"
            :scrolling="{ useNative: true }"
            :data-source="detailproduct"
            key-expr="ID_Item"
            @exporting="onExporting"
            @row-updating="onDetailRowUpdating"
            @row-prepared="onRowPrepared"
          >
            <DxExport :enabled="true" />
            <DxEditing
              :allow-updating="true"
              :select-text-on-edit-start="true"
              start-edit-action="click"
              mode="cell"
            />
            <DxColumn
              :width="columnWidth"
              :allow-editing="false"
              data-field="ID_Item"
              caption="ID de Insumo"
            ></DxColumn>
            <DxColumn
              :width="columnWidth"
              :allow-editing="false"
              data-field="ItemComercialName"
              caption="Nombre Comercial"
            ></DxColumn>
            <DxColumn
              :width="columnWidth"
              :allow-editing="false"
              data-field="ItemName"
              caption="Nombre"
            ></DxColumn>
            <DxColumn
              :width="columnWidth"
              cell-template="lote-template2"
              data-field="ItemLote"
              caption="Lote"
            ></DxColumn>
            <template #lote-template2="{ data }">
              {{
                data.data.ID_ItemBatch
                  ? data.data.ID_ItemBatch
                  : "Por defecto"
              }}
            </template>
            <DxColumn
              :width="columnWidth"
              :allow-editing="false"
              data-field="Warehouse"
              caption="Almacen de Origen"
            ></DxColumn>
            <DxColumn
              :width="columnWidth"
              :allow-editing="false"
              data-field="QuantityBase"
              caption="Cantidad Base"
            ></DxColumn>
            <DxColumn
              :width="columnWidth"
              :allow-editing="false"
              data-field="ItemCurrentQuantity"
              caption="Existencia Actual"
              cell-template="stock-status-template"
            ></DxColumn>
            <template #stock-status-template="{ data }">
              <span :style="getStockStyle(data.data)">
                {{ data.data.ItemCurrentQuantity }}
              </span>
            </template>
            <DxColumn
              data-field="Quantity"
              caption="Unidad a transferir"
              cell-header-template="headerNameAmount"
              data-type="number"
            >
            </DxColumn>
            <template #headerNameAmount="{}"
              ><div>Unidades a<br />transferir</div></template
            >
            <DxColumn
              :width="columnWidth"
              :allow-editing="false"
              cell-template="stock-origin"
              caption="Nueva Existencia"
            ></DxColumn>
            <template #stock-origin="{ data }">
              {{ calculateCellValue(data.data) }}
            </template>
            <DxColumn
              :width="columnWidth"
              :allow-editing="false"
              data-field="ID_User_Insert"
              caption="Usuario que Realiza"
            ></DxColumn>
            <DxColumn
              :width="columnWidth"
              :allow-editing="false"
              data-field="ID_User_Update"
              caption="Usuario que Actualiza"
            ></DxColumn>
          </DxDataGrid>
        </v-card-text>
      </v-card>
    </v-dialog>
    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    ></alerts>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import GeneralFilter from "@/components/GeneralFilter.vue";
import VersatileFilter from "@/components/VersatileFilter";
import Block from "@/components/Block.vue";
import Spinner from "@/components/DashboardStats/spinner.vue";
import { printToExcel } from "@/helpers/printToexcel";
import { quillConfig } from "@/helpers/quillconfig";
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxExport,
  DxEditing,
} from "devextreme-vue/data-grid";
import Alerts from "@/components/Alerts.vue";

export default {
  name: "CreateTransfer",
  components: {
    DatePicker,
    GeneralFilter,
    DxDataGrid,
    DxPaging,
    DxColumn,
    DxExport,
    DxEditing,
    VersatileFilter,
    Alerts,
    Block,
    Spinner,
  },
  data() {
    return {
      date: null,
      counter: 0,
      showNotes: false,
      showPrices: false,
      productsToShowWarehouse: [],
      detailProductTransfer: false,
      hasInsufficientStockInDetail: false,
      currentProductName: '',
      showDeselect: false,
      productsToShow: [],
      productTransferShow: [],
      products: [],
      loadingProducts: false,
      productsToTransfer: [],
      detailproduct: [],
      warehouses: [],
      filterWarehouses: {},
      quillOptions: quillConfig,
      transferRequestActive: false,
      requestStatus: null,
      requestId: null,
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      showFilter: false,
      families: [],
      categories: [],
      subcategories: [],
      providers: [],
      form: {
        warehouseOrigin: "",
        warehouseDestination: "",
        comments: "",
      },
      inventory: [],
      search: {
        filter: null,
      },
      filter: {
        family: null,
        category: null,
        subcategory: null,
        providers: null,
      },
      columsConfig: [
        {
          name: "PR.family",
          title: "Familia",
          value: "",
          type: "select",
          options: [],
        },
        {
          name: "PR.category",
          title: "Categoría",
          value: "",
          parent: "PR.family",
          type: "select",
          options: [],
        },
        {
          name: "PR.subcategory",
          title: "Subcategoría",
          value: "",
          parent: "PR.category",
          type: "select",
          options: [],
        },
      ],
      loading: false,
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      currentProductIndex: null,
    };
  },
  computed: {
    productsToTransferCalc() {
      const items = this.productsToTransfer.map((item) => {
        const composedOf = item.composedOf.map((item2) => {
          return { ...item2, Quantity: item.Quantity * item2.QuantityBase };
        });
        return { ...item, composedOf };
      });
      return items;
    },
    productsSelected() {
      return this.products.filter((item) => item.checkbox);
    },
    isSelectedtAll() {
      return this.productsSelected.length === this.products.length;
    },
    columnWidth() {
      return this.$vuetify.breakpoint.smAndDown ? "160px" : "auto !important";
    },
    filteredCategories() {
      return this.filter.family
        ? this.categories.filter(
            (category) => category.id_family == this.filter.family
          )
        : [];
    },
    filteredSubcategories() {
      return this.filter.category
        ? this.subcategories.filter(
            (subcategory) => subcategory.id_cat == this.filter.category
          )
        : [];
    },
    filteredWarehousesForOrigin() {
      return this.warehouses.filter(
        (warehouse) => warehouse.ID_Warehouse != this.form.warehouseDestination
      );
    },
    filteredWarehousesForDestination() {
      return this.warehouses.filter(
        (warehouse) => warehouse.ID_Warehouse != this.form.warehouseOrigin
      );
    },
  },
  mounted() {
    this.search.business = JSON.parse(localStorage.getItem("user")).businessid;
    this.search.branch = JSON.parse(localStorage.getItem("user")).branch;
    this.search.type = 0;
    this.getWarehouse();
    this.getFamilies();
    this.getCategories();
    this.getCategories();
    this.getSubs();
  },
  methods: {
    removeRow(data) {
      this.productsToTransfer.splice(data.rowIndex, 1)
    },
    async addNewTransfer() {
      // Validar que hay productos para transferir
      if (!this.productsToTransfer || this.productsToTransfer.length === 0) {
        this.showAlert(
          "danger",
          "Error",
          "No hay productos para realizar la combinación"
        );
        return;
      }

      // Validar que los almacenes están seleccionados
      if (!this.form.warehouseOrigin || !this.form.warehouseDestination) {
        this.showAlert(
          "danger",
          "Error",
          "Debe seleccionar el almacén de origen y destino"
        );
        return;
      }

      // Validar que todos los productos tienen cantidad a transferir
      if (this.productsToTransferCalc.some(item => item.Quantity <= 0)) {
        this.showAlert(
          "danger",
          "Error",
          "Verifique que todos los elementos del listado tengan unidades a transferir"
        );
        return;
      }
      
      this.loading = true;
      
      try {
        // Validar existencias en el backend antes de proceder
        const validationBody = {
          ID_WarehouseOrigin: this.form.warehouseOrigin,
          Products: this.productsToTransferCalc,
        };

        const validationResult = await this.$API.inventoryTransfer.validateStockBeforeCombination(validationBody);

        // Si la validación del backend indica que no hay existencia suficiente
        if (validationResult.hasInsufficientStock) {
          this.loading = false;
          
          // Cerrar cualquier edición pendiente
          if (this.$refs.mainDataGrid && this.$refs.mainDataGrid.instance) {
            this.$refs.mainDataGrid.instance.cancelEditData();
          }
          
          // Encontrar el índice del primer producto con problemas en la lista actual
          const firstProductWithIssue = validationResult.productsWithInsufficientStock[0];
          const productIndex = this.productsToTransfer.findIndex(
            p => p.ID_Item === firstProductWithIssue.productId
          );
          
          // Abrir el modal de detalles del primer producto con problemas
          if (productIndex !== -1) {
            // Calcular las cantidades actualizadas para el producto
            const product = this.productsToTransfer[productIndex];
            const updatedComposedOf = product.composedOf.map(comp => ({
              ...comp,
              Quantity: product.Quantity * comp.QuantityBase
            }));
            
            // Pasar el nombre del producto desde la respuesta del backend
            const productName = firstProductWithIssue.productName || product.ItemComercialName || product.ItemName;
            this.productsTransferShow(updatedComposedOf, productIndex, true, productName);
          }
          return;
        }

        // Si la validación pasó, proceder con la combinación
        const body = {
          ID_WarehouseOrigin: this.form.warehouseOrigin,
          ID_WarehouseDestination: this.form.warehouseDestination,
          isRequest: 1,
          comments: this.form.comments,
          Products: this.productsToTransferCalc,
        };

        const result =
          await this.$API.inventoryTransfer.addTransferProductComposite(body);

        this.loading = false;
        if (result?.success) {
          const warning = result.externalStoreSyncWarning;
          this.showAlert(
            warning ? "warning" : "success",
            warning ? "Combinación guardada" : "Exito",
            warning ? result.message + " " + warning : result.message
          );
          this.cleanData();
        } else {
          this.showAlert("danger", "Error", result?.message);
        }
      } catch (error) {
        this.loading = false;
        this.showAlert(
          "danger",
          "Error",
          "Error al guardar el traspaso " + error.message
        );
      }
    },
    cleanData() {
      this.productTransferShow = [];
      this.products = [];
      this.productsToTransfer = [];
      this.detailproduct = [];
      this.filterWarehouses = {};
      this.search = {
        filter: null,
      };
      (this.form = {
        warehouseOrigin: "",
        warehouseDestination: "",
        comments: "",
      }),
        (this.filterWarehouses = {});
    },
    clearFilters() {
      this.filter.family = null;
      this.filter.category = null;
      this.filter.subcategory = null;
      this.filter.providers = null;
    },
    productsTransferShow(data, rowIndex, useProvidedData = false, productName = null) {
      // Si se proporciona data específica, usarla (para casos de validación con cantidades actualizadas)
      // De lo contrario, usar los datos calculados del producto
      if (useProvidedData && data) {
        this.detailproduct = data;
        // Marcar que hay problemas de existencia si viene de una validación
        this.hasInsufficientStockInDetail = true;
      } else {
        this.detailproduct = this.productsToTransferCalc[rowIndex].composedOf;
        this.hasInsufficientStockInDetail = false;
      }
      this.currentProductIndex = rowIndex;
      // Guardar el nombre del producto principal
      if (productName) {
        this.currentProductName = productName;
      } else if (rowIndex !== null && this.productsToTransfer[rowIndex]) {
        this.currentProductName = this.productsToTransfer[rowIndex].ItemComercialName || this.productsToTransfer[rowIndex].ItemName;
      }
      // console.log('this.detailproduct', this.detailproduct);
      this.detailProductTransfer = true;
    },
    closeDetailModal() {
      // Cerrar cualquier edición en el DataGrid principal
      if (this.$refs.mainDataGrid && this.$refs.mainDataGrid.instance) {
        this.$refs.mainDataGrid.instance.cancelEditData();
      }
      
      // Cerrar cualquier edición en el DataGrid de detalles
      if (this.$refs.dxDataGridTransfer && this.$refs.dxDataGridTransfer.instance) {
        this.$refs.dxDataGridTransfer.instance.cancelEditData();
      }
      
      this.detailProductTransfer = false;
      this.hasInsufficientStockInDetail = false;
      this.currentProductName = '';
      this.detailproduct = [];
    },
    getStockStyle(data) {
      // Si HasStock es 0 o la cantidad actual es menor a la requerida, resaltar en rojo
      if (data.HasStock === 0 || data.ItemCurrentQuantity < data.Quantity) {
        return 'color: #ff0000; font-weight: bold;';
      }
      return '';
    },
    onRowPrepared(e) {
      // Aplicar clase CSS a las filas sin existencia suficiente
      if (e.rowType === 'data') {
        const hasInsufficientStock = e.data.HasStock === 0 || 
                                     e.data.ItemCurrentQuantity < e.data.Quantity;
        if (hasInsufficientStock) {
          e.rowElement.classList.add('insufficient-stock');
        }
      }
    },
    onMainRowUpdating(e) {
      // Validar cuando se actualiza la cantidad en el grid principal
      if (e.newData.Quantity !== undefined) {
        const newQuantity = e.newData.Quantity;
        const product = e.oldData;
        
        // Verificar si algún componente no tendrá suficiente existencia con la nueva cantidad
        const componentsWithInsufficient = [];
        
        for (const component of product.composedOf) {
          const requiredQuantity = newQuantity * component.QuantityBase;
          const availableStock = component.ItemCurrentQuantity || 0;
          
          if (component.HasStock === 0 || availableStock < requiredQuantity) {
            componentsWithInsufficient.push({
              name: component.ItemComercialName || component.ItemName,
              available: availableStock,
              required: requiredQuantity,
              quantityBase: component.QuantityBase,
              units: newQuantity
            });
          }
        }
        
        if (componentsWithInsufficient.length > 0) {
          e.cancel = true;
          
          // Encontrar el índice del producto en la lista
          const productIndex = this.productsToTransfer.findIndex(
            p => p.ID_Item === product.ID_Item
          );
          
          // Cerrar el editor y abrir el modal después
          this.$nextTick(() => {
            // Cancelar cualquier edición en curso
            if (this.$refs.mainDataGrid && this.$refs.mainDataGrid.instance) {
              this.$refs.mainDataGrid.instance.cancelEditData();
            }
            
            // Abrir el modal de detalles para mostrar en rojo los componentes sin existencia
            if (productIndex !== -1) {
              // Actualizar las cantidades en composedOf para que se calculen correctamente
              const updatedComposedOf = product.composedOf.map(comp => ({
                ...comp,
                Quantity: newQuantity * comp.QuantityBase
              }));
              
              // Obtener el nombre del producto
              const productName = product.ItemComercialName || product.ItemName;
              // Usar el tercer parámetro true para indicar que use los datos proporcionados
              this.productsTransferShow(updatedComposedOf, productIndex, true, productName);
            }
          });
        }
      }
    },
    onDetailRowUpdating(e) {
      // Validar cuando se actualiza la cantidad en el detalle
      if (e.newData.Quantity !== undefined) {
        const currentStock = e.oldData.ItemCurrentQuantity || 0;
        const newQuantity = e.newData.Quantity;
        
        if (newQuantity > currentStock) {
          e.cancel = true;
          this.showAlert(
            "danger",
            "No tiene Existencia",
            `No hay suficiente existencia de "${e.oldData.ItemComercialName || e.oldData.ItemName}". Disponible: ${currentStock}, solicitado: ${newQuantity}`
          );
        }
      }
    },
    validateStockAvailability() {
      // Validar que todos los productos tengan existencia suficiente
      const productsWithoutStock = [];
      
      for (const product of this.productsToTransferCalc) {
        for (const component of product.composedOf) {
          if (component.HasStock === 0 || component.ItemCurrentQuantity < component.Quantity) {
            productsWithoutStock.push({
              productName: product.ItemComercialName || product.ItemName,
              componentName: component.ItemComercialName || component.ItemName,
              available: component.ItemCurrentQuantity || 0,
              required: component.Quantity,
              quantityBase: component.QuantityBase,
              units: product.Quantity
            });
          }
        }
      }
      
      return productsWithoutStock;
    },
    calculateExistenciaDestino(data) {
      data.StockResultAtDestination = data.ItemCurrentQuantity + data.Quantity;
      const stockDestino = data.StockResultAtDestination;
      return stockDestino;
    },
    calculateCellValue(data) {
      data.StockResultOrigin = data.ItemCurrentQuantity - data.Quantity;
      const stockOrigen = data.StockResultOrigin;
      return stockOrigen;
    },
    addProducts() {
      const productsToAdd = JSON.parse(JSON.stringify(this.productsSelected));
      
      // Filtrar productos que no estén ya agregados (evitar duplicados)
      const newProducts = productsToAdd.filter(newProduct => 
        !this.productsToTransfer.some(existingProduct => 
          existingProduct.ID_Item === newProduct.ID_Item
        )
      );
      
      // Agregar los nuevos productos a los existentes
      this.productsToTransfer = [...this.productsToTransfer, ...newProducts];
      
      this.closeDialogShowPrices();
      console.log(JSON.parse(JSON.stringify(this.productsToTransfer)));
    },
    filterTransferProduct({ filter, products }) {
      let filteredProducts = products.filter(
        (product) =>
          product.ID_Item.toString().includes(filter) ||
          product.ItemName.includes(filter) ||
          product.Quantity.toString().includes(filter) ||
          product.ItemCurrentQuantity.toString().includes(filter)
      );

      return new Promise((resolve) => {
        resolve(filteredProducts);
      });
    },

    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    closeAlert() {
      this.alert.show = false;
    },
    acceptAlert() {
      this.alert.show = false

      if (this.alert.options == "clientLinkList") {
        this.addPriceListToClient()
      }
    },
    getWarehouse() {
      let idbusiness =
        JSON.parse(localStorage.getItem("user")).businessid || "";
      let idbranch = JSON.parse(localStorage.getItem("user")).branch || "";
      this.filterWarehouses.branch = idbranch;
      this.filterWarehouses.business = idbusiness;
      this.$API.warehouse
        .getWarehouses({...this.filterWarehouses, notShowReserve: 1 })
        .then((response) => {
          this.warehouses = response;
        });
    },

    getItemsFromWarehouseOrigin() {
      this.inventory = this.productsToShowWarehouse.filter(
        (product) => product.Warehouse == this.form.warehouseOrigin
      );
    },

    selectAll() {
      this.products.forEach((element) => {
        element.checkbox = true;
      })
      this.counter = this.products.length;
      this.showDeselect = true;
    },

    deselectAll() {
      this.products.forEach((element) => {
        element.checkbox = false;
      })
      this.showDeselect = false;
      this.counter = 0;
    },

    updateCounter() {
      this.counter = 0;
      this.products.forEach((element) => {
        if (element.checkbox) {
          this.counter++
        }
      })
    },

    closeDialogShowPrices() {
      this.deselectAll();
      this.showPrices = false; 
    },

    onEditorChange(e) {
      this.form.comments = e.html;
    },

    filterHandler(response) {
      this.productsToShow = response;
    },

    handleInventoryFilter(response) {
      if (response.length === 0 && this.didHaveAllData === false) {
        this.didHaveAllData = true;
        this.getInventoryListAll();
        this.$refs.generalFilter.filterHandler();
      }
      this.inventory = response.filter(
        (product) => product.Warehouse == this.form.warehouseOrigin
      );
    },

    getProductsToShow() {
      this.productsToShow = JSON.parse(
        JSON.stringify(this.productsToShowFilter)
      );
    },

    clearInventoryFilter() {
      // this.isInventoryFiltered = false;
      this.getInventory();
      this.getItemsFromWarehouseOrigin();
    },

    getInventory() {
      this.$API.products
        .getProductInventoryHistory()
        .then((response) => {
          this.inventory = response;
          this.productsToShowWarehouse = response;
          // this.fillDataFromTransfer();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onExporting(e) {
      printToExcel(e, "Lista de Precios ");
    },

    getFamilies() {
      this.$API.itemtypes.getFamilies().then((response) => {
        this.families = response;
        this.columsConfig[0].options = response.map((fam) => ({
          name: fam.name,
          value: fam.id,
        }));
      });
    },
    getCategories() {
      this.$API.itemtypes.getCategories().then((response) => {
        this.categories = response;
        this.columsConfig[1].options = response.map((cat) => ({
          name: cat.name,
          value: cat.id,
          parent_id: cat.id_family,
        }));
      });
    },
    getSubs() {
      this.$API.itemtypes.getSubs().then((response) => {
        this.subcategories = response;
        this.columsConfig[2].options = response.map((sub) => ({
          name: sub.name,
          value: sub.id,
          parent_id: sub.id_cat,
        }));
      });
    },
  },
  watch: {
    async showPrices(value) {
      if (value) {
        try {
          this.loadingProducts = true;
          const products =
            await this.$API.inventoryTransfer.getProductListComposite(
              this.form.warehouseOrigin,
              this.form.warehouseDestination,
              ""
            );
          this.products = products.map((item) => {
            item.composedOf = item.composedOf.map((item2) => {
              item2.Quantity = 0;
              return item2;
            });
            item.Quantity = 0;
            return item;
          });
        } catch (error) {
          console.error('Error cargando productos:', error);
          this.showAlert(
            "danger",
            "Error",
            "Error al cargar los productos: " + error.message
          );
        } finally {
          this.loadingProducts = false;
        }
      }
    },
  },
};
</script>

<style scoped>
/* Estilos para resaltar productos sin existencia */
::v-deep .dx-row.insufficient-stock {
  background-color: #ffebee !important;
}

::v-deep .dx-row.insufficient-stock:hover {
  background-color: #ffcdd2 !important;
}

::v-deep .stock-warning {
  color: #d32f2f;
  font-weight: bold;
}
</style>
